import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import myungin from "../../assets/images/speakers/myungin.jpg";

function Myungin() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Colony Ballroom</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={myungin} alt="Myungin Lee" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Myungin Lee</h1>
      <h2>Faculty in Immersive Media Design</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Myungin Lee is an artist–researcher designing multimodal XR experiences at the intersection of human–computer interaction, signal processing, and machine learning. His practice centers on art–science collaboration that not only supports education but also accelerates discovery—from brain–computer interaction and generative AI to environmental ocean data and quantum simulation in XR.
He holds a Ph.D. in Media Arts & Technology from UC Santa Barbara (AlloSphere Research Group) and B.S./M.S. degrees in Electronics & Computer Engineering from Hanyang University, Korea. He has served as faculty in Immersive Media Design at the University of Maryland, College Park, and as a Ph.D. research intern at Nokia Bell Labs’ Experiments in Art & Technology (E.A.T.). His work has appeared at Ars Electronica, Getty’s PST ART: Art & Science Collide, IEEE VIS, ACM CHI, NIME, ICMC, and the ACM SIGGRAPH community.
      </p>
      <a href="https://www.linkedin.com/in/myungin-lee-3377a6112" target="_blank" rel="noreferrer" className="btn" style={{margin: "2rem auto", fontWeight: 400, fontSize: '20px', borderRadius: '0px'}} >
      Linkedin </a> 
      <a href="https://www.myunginlee.com/" target="_blank" rel="noreferrer" className="btn" style={{margin: "2rem auto", fontWeight: 400, fontSize: '20px', borderRadius: '0px'}} >
      Personal Website </a> 
    </div>
    </>
  );
}

export default Myungin;